var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoUserProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.57,
    height: 128.08,
    viewBox: "0 0 73.57 128.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_76_1",
    "data-name": "Component 76 \\u2013 1",
    transform: "translate(2.5 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9072",
    "data-name": "Path 9072",
    d: "M36.79,75,25,59.24H2.5v66.35H60.22a10.94,10.94,0,0,0,10.85-10.85V59.24H48.87Z",
    transform: "translate(-2.5 -2.51)",
    fill: "#64ccc9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_659",
    "data-name": "Ellipse 659",
    cx: 24.91,
    cy: 24.91,
    r: 24.91,
    transform: "translate(9.369)",
    fill: "#fff",
    stroke: "#02339e",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9073",
    "data-name": "Path 9073",
    d: "M36.79,75,25,59.24H2.5v66.35H60.22a10.94,10.94,0,0,0,10.85-10.85V59.24H48.87Z",
    transform: "translate(-2.5 -2.51)",
    fill: "none",
    stroke: "#02339e",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUserProfile);
export default __webpack_public_path__ + "static/media/ico-UserProfile.1a0d14648f27a80ade7dee313e886d89.svg";
export { ForwardRef as ReactComponent };